import { __decorate, __extends } from "tslib";
import { BlurTask } from './tasks/BlurTask';
import { FilterBase } from './FilterBase';
import { FilterUtils, serialisable } from '../utils/FilterUtils';
import { Rectangle } from '@awayjs/core';
var BlurFilter = /** @class */ (function (_super) {
    __extends(BlurFilter, _super);
    function BlurFilter(props) {
        var _this = _super.call(this) || this;
        _this.quality = 1;
        _this.imageScale = 1;
        //@serialisable
        //@proxyTo('_hBlurTask', 'amount')
        _this.blurX = 1;
        //@serialisable
        //@proxyTo('_vBlurTask', 'amount')
        _this.blurY = 1;
        _this._hBlurTask = new BlurTask(3, true);
        _this._vBlurTask = new BlurTask(3, false);
        _this.addTask(_this._hBlurTask);
        _this.addTask(_this._vBlurTask);
        props && _this.applyProps(props);
        return _this;
    }
    BlurFilter.prototype.applyProps = function (props) {
        var kernel;
        var blurX = this.blurX = props.blurX;
        var blurY = this.blurY = props.blurY;
        var quality = props.quality || 1;
        blurX = blurX > 1 ? blurX - 1 : 0;
        blurY = blurY > 1 ? blurY - 1 : 0;
        switch (quality) {
            case 1: {
                kernel = 2;
                break;
            }
            case 2: {
                kernel = 3;
                blurX *= 1.05;
                blurY *= 1.05;
                break;
            }
            default: {
                blurX *= 0.65;
                blurY *= 0.65;
                kernel = 5;
            }
        }
        this._hBlurTask.stepSize = blurX;
        this._vBlurTask.stepSize = blurY;
        this._hBlurTask.kernel = this._vBlurTask.kernel = kernel;
        var maxAmount = Math.max(blurX, blurY);
        quality = 1;
        while (maxAmount >= 1.1) {
            maxAmount /= 2;
            quality++;
        }
        this.quality = quality + 1;
    };
    BlurFilter.prototype.apply = function (source, target, sourceRect, destRect, filterManager, clearOutput) {
        var _a;
        if (clearOutput === void 0) { clearOutput = false; }
        var passes = this.quality;
        var stepX = this._hBlurTask.stepSize;
        var stepY = this._vBlurTask.stepSize;
        var n = 1;
        var t = 1;
        for (var i = 1; i < passes; i++) {
            t *= 2;
            n += t;
        }
        this._hBlurTask.stepSize = stepX / n;
        this._vBlurTask.stepSize = stepY / n;
        if (passes === 1) {
            return _super.prototype.apply.call(this, source, target, sourceRect, destRect, filterManager, clearOutput);
        }
        else {
            var tmp1 = filterManager.popTemp(source.width, source.height);
            var tmp2 = passes > 2 ? filterManager.popTemp(source.width, source.height) : null;
            _super.prototype.apply.call(this, source, tmp1, sourceRect, tmp1.rect, filterManager, true);
            for (var i = 1; i < passes - 1; i++) {
                this._hBlurTask.stepSize *= 2;
                this._vBlurTask.stepSize *= 2;
                _super.prototype.apply.call(this, tmp1, tmp2, tmp1.rect, tmp2.rect, filterManager, false);
                _a = [tmp2, tmp1], tmp1 = _a[0], tmp2 = _a[1];
            }
            this._hBlurTask.stepSize *= 2;
            this._vBlurTask.stepSize *= 2;
            _super.prototype.apply.call(this, tmp1, target, tmp1.rect, destRect, filterManager, clearOutput);
            filterManager.pushTemp(tmp1);
            filterManager.pushTemp(tmp2);
        }
        this._hBlurTask.stepSize = stepX;
        this._vBlurTask.stepSize = stepY;
    };
    BlurFilter.prototype.meashurePad = function (input, target) {
        if (target === void 0) { target = input; }
        var pad = FilterUtils.meashureBlurPad(this.blurX, this.blurY, this.quality, true);
        target.copyFrom(input);
        target.x -= pad.x * 2;
        target.y -= pad.y * 2;
        target.width += pad.x * 2;
        target.height += pad.y * 2;
        return target;
    };
    BlurFilter.prototype.setRenderState = function (source, target, sourceRect, outRect, filterManage) {
        var subPassTarget = filterManage.popTemp(source.width, source.height);
        // TEMP target can be dirty, because we use offset, clear it
        this._hBlurTask.needClear = true;
        // we not cut region, because in this case blur will emit invalid data on edge
        this._hBlurTask.inputRect.setTo(0, 0, source.width, source.height);
        // apply padding
        this._hBlurTask.destRect.setTo(0, 0, source.width, source.height);
        // but we can use a clip to kill non-used
        this._vBlurTask.clipRect = new Rectangle(0, 0, source.width, source.height);
        this._hBlurTask.clipRect = this._vBlurTask.clipRect;
        // emit real
        // crop a dest rectanle
        this._vBlurTask.inputRect.copyFrom(outRect);
        this._vBlurTask.destRect.copyFrom(outRect);
        this._hBlurTask.source = source;
        this._hBlurTask.target = subPassTarget;
        this._vBlurTask.source = subPassTarget;
        this._vBlurTask.target = target;
        this._temp = [subPassTarget];
    };
    BlurFilter.filterName = 'blur';
    __decorate([
        serialisable
    ], BlurFilter.prototype, "imageScale", void 0);
    return BlurFilter;
}(FilterBase));
export { BlurFilter };
